<script lang="ts">
  import {VideoService} from '@/services';
  import Dialog from '../../../components/dialog/Dialog.svelte';
  import type {Video} from '@/types/project';
  import Swal from 'sweetalert2';
  import {createEventDispatcher} from 'svelte';

  export let video: Video | null;

  const videoService = new VideoService();

  let isRenamingVideo = false;
  let name = '';
  let isRenameDialogOpen = false;

  $: if (name === '' && video && video?.title !== '') name = video.title;
  $: isRenameDialogOpen = Boolean(video && video.title !== '');

  const dispatch = createEventDispatcher();

  async function renameVideo() {
    if (!video) return console.log('video is empty');

    isRenamingVideo = true;

    videoService
      .updateVideoName(`${video.id}`, name)
      .then(() => {
        if (!video) throw 'video is null';

        video.title = name;
        dispatch('rename');
        name = '';
        video = null;

        Swal.fire({
          title: 'Video Updated',
          icon: 'success',
          timer: 500,
          timerProgressBar: true
        });
      })
      .catch(error => {
        console.error('delete error', error);
        Swal.fire({
          position: 'bottom-end',
          icon: 'error',
          title: 'Failed to Delete Video',
          showConfirmButton: false,
          timer: 1500,
          toast: true
        });
      })
      .finally(() => {
        isRenamingVideo = false;
      });
  }
</script>

<Dialog bind:isDialogOpen={isRenameDialogOpen} useIfShow={true}>
  <div class="pointer-events-none flex h-full w-full items-end justify-center lg:items-center">
    <div
      class="pointer-events-auto h-auto w-full min-w-[280px] rounded-t-2xl border border-zinc-400 bg-white p-12 shadow-lg dark:border-zinc-600 dark:bg-zinc-700 lg:max-w-[680px] lg:rounded-3xl"
    >
      <div class="flex items-center pb-2 pt-6 text-zinc-900 dark:text-zinc-200">
        <div class="flex items-center gap-3 py-1.5">
          <!-- <div class="rounded-full px-2 p-2 font-bold bg-rose-500 text-zinc-100 flex items-center">
                        <i class="fa-solid fa-pen"></i>
                    </div> -->
          <h1 class="text-lg font-bold text-dark dark:text-rose-500">Edit Video Name</h1>
        </div>
        <button
          on:click={() => (isRenameDialogOpen = false)}
          class="ml-auto mr-2 rounded-lg hover:bg-zinc-100 dark:hover:bg-zinc-600"
        >
          <i class="fa-solid fa-x"></i>
        </button>
      </div>
      <!-- <hr class="border dark:border-zinc-600"> -->
      <div class="grid pt-2">
        <div class="py-2">
          <label for="name" class="block text-sm font-medium text-gray-800 dark:text-zinc-200">Video Name</label>
          <div class="flex pt-2">
            <input
              bind:value={name}
              name="name"
              type="text"
              placeholder=""
              class="block w-full rounded rounded-tl-lg border border-gray-300 bg-gray-50 px-4 py-2.5 text-gray-500 placeholder-gray-300 focus:border-primary focus:outline-none focus:ring focus:ring-primary focus:ring-opacity-40 dark:border-zinc-600 dark:bg-zinc-800 dark:text-zinc-200 dark:placeholder-zinc-500 dark:focus:border-blue-300"
              required
            />
          </div>
        </div>
      </div>
      <!-- <hr class="border dark:border-zinc-600"> -->
      <div class="flex justify-end gap-2 pt-6">
        <button
          on:click={() => (isRenameDialogOpen = false)}
          class="{isRenamingVideo
            ? 'bg-zinc-100'
            : 'border border-2 border-zinc-400'} flex flex w-full items-center items-center justify-center rounded-md px-3 py-2 font-medium text-zinc-400 lg:w-auto"
          disabled={isRenamingVideo}
        >
          <span>Cancel</span>
        </button>
        <button
          on:click={() => renameVideo()}
          class="flex flex w-full items-center items-center justify-center gap-1 rounded-md bg-rose-500 px-3 py-2 font-medium text-zinc-100 hover:bg-rose-600 lg:w-auto"
          disabled={isRenamingVideo}
        >
          <div
            class="{isRenamingVideo
              ? ''
              : 'hidden'} spinner h-4 w-4 !border-zinc-100 !border-t-rose-500 dark:!border-zinc-700 dark:!border-t-rose-500"
          ></div>
          <!-- <i class="{isRenamingVideo ? 'hidden' : ''} fa-solid fa-floppy-disk" /> -->
          <span>Save Project</span>
        </button>
      </div>
    </div>
  </div>
</Dialog>
